angular.module('bookAndPay', ['gym.components', 'ui.router', 'ui.bootstrap', 'infinite-scroll', 'shared', 'restangular', 'shared', 'filters', 'tandibar/ng-rollbar', 'angular-flash.service', 'angular-flash.flash-alert-directive', 'react']).run(["Restangular", "restangularInterceptors", "$rootScope", "$window", function(Restangular, restangularInterceptors, $rootScope, $window) {
  Restangular.addRequestInterceptor(restangularInterceptors.RequestInterceptor).addResponseInterceptor(restangularInterceptors.ResponseInterceptor);
  return $rootScope.$on('$stateChangeStart', function(event, toState, toParams) {
    var confirmMessage;
    confirmMessage = $rootScope.stateChangeConfirmMessage;
    if (confirmMessage && !$window.confirm(confirmMessage)) {
      event.preventDefault();
    } else {
      $rootScope.stateChangeConfirmMessage = void 0;
      return $window.onbeforeunload = void 0;
    }
  });
}]).config(["$locationProvider", "$stateProvider", "$httpProvider", "RestangularProvider", "RollbarProvider", function($locationProvider, $stateProvider, $httpProvider, RestangularProvider, RollbarProvider) {
  var meta;
  meta = angular.element(document.querySelectorAll('meta[name=csrf-token]'));
  $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-Token';
  $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
  $locationProvider.html5Mode(true);
  RollbarProvider.init(window._rollbarConfig);
  RestangularProvider.setBaseUrl(`/websites/${window.DATA.domain}/book_and_pay`);
  return $stateProvider.state('bookAndPay', {
    url: '/websites/:domain/book_and_pay',
    abstract: true,
    template: '<ui-view>'
  }).state('bookAndPay.newCart', {
    url: '/offers/:uuid/carts/new?ct&ce&eid&flash',
    controller: 'NewCartCtrl',
    template: require('templates/book_and_pay/new_cart.html.slim'),
    resolve: {
      newCart: ["$stateParams", "Restangular", "$q", function($stateParams, Restangular, $q) {
        return Restangular.one('offers', $stateParams.uuid).one('carts', 'new').get({
          ct: $stateParams.ct
        }).then(function(response) {
          return response;
        }, function(response) {
          if (response.data.redirect_url) {
            window.location.href = response.data.redirect_url;
          }
          return $q.reject();
        });
      }]
    }
  }).state('bookAndPay.editCart', {
    url: '/carts/:uuid',
    controller: 'EditCartCtrl',
    template: require('templates/book_and_pay/edit_cart.html.slim'),
    resolve: {
      cart: ["$stateParams", "Restangular", "$q", function($stateParams, Restangular, $q) {
        Restangular.configuration.getIdFromElem = function(elem) {
          return elem['cart_uuid'] || elem['id'];
        };
        return Restangular.one('carts', $stateParams.uuid).get().then(function(response) {
          return response;
        }, function(response) {
          if (response.data.redirect_url) {
            window.location.href = response.data.redirect_url;
          }
          return $q.reject();
        });
      }]
    }
  }).state('bookAndPay.showEvents', {
    url: '/carts/:uuid/events',
    controller: 'ShowEventsCtrl',
    template: require('templates/book_and_pay/show_events.html.slim'),
    resolve: {
      cart: ["$stateParams", "Restangular", "$q", function($stateParams, Restangular, $q) {
        Restangular.configuration.getIdFromElem = function(elem) {
          return elem['cart_uuid'] || elem['id'];
        };
        return Restangular.one('carts', $stateParams.uuid).get().then(function(response) {
          return response;
        }, function(response) {
          if (response.data.redirect_url) {
            window.location.href = response.data.redirect_url;
          }
          return $q.reject();
        });
      }],
      events: ["$stateParams", "Restangular", "$q", function($stateParams, Restangular, $q) {
        return Restangular.one('carts', $stateParams.uuid).all('events').getList().then(function(response) {
          return response;
        }, function(response) {
          if (response.data.redirect_url) {
            window.location.href = response.data.redirect_url;
            return $q.reject();
          } else {
            return response.data;
          }
        });
      }]
    }
  }).state('bookAndPay.processPayment', {
    url: '/carts/:uuid/process_payment',
    controller: 'ProcessPaymentCtrl',
    template: require('templates/book_and_pay/process_payment.html.slim'),
    resolve: {
      cart: ["$stateParams", "Restangular", "$q", function($stateParams, Restangular, $q) {
        return Restangular.one('carts', $stateParams.uuid).customGET('process_payment').then(function(response) {
          return response;
        }, function(response) {
          if (response.data.redirect_url) {
            window.location.href = response.data.redirect_url;
          }
          return $q.reject();
        });
      }]
    }
  }).state('bookAndPay.complete', {
    url: '/carts/:uuid/complete',
    controller: 'CompleteCtrl',
    template: require('templates/book_and_pay/complete.html.slim'),
    resolve: {
      cart: ["$stateParams", "Restangular", "$q", function($stateParams, Restangular, $q) {
        return Restangular.one('carts', $stateParams.uuid).customGET('complete').then(function(response) {
          return response;
        }, function(response) {
          if (response.data.redirect_url) {
            window.location.href = response.data.redirect_url;
          }
          return $q.reject();
        });
      }]
    }
  }).state('bookAndPay.sampleComplete', {
    url: '/offers/:uuid/carts/sample_complete?ct',
    controller: 'SampleCompleteCtrl',
    template: require('templates/book_and_pay/complete.html.slim'),
    resolve: {
      cart: ["$stateParams", "Restangular", function($stateParams, Restangular) {
        return Restangular.one('offers', $stateParams.uuid).one('carts', 'sample_complete').get({
          ct: $stateParams.ct
        });
      }]
    }
  });
}]);
